/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_GxoInputs */

const en_node_gxo = /** @type {(inputs: Node_GxoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GXO warehouse`)
};

/**
* | output |
* | --- |
* | "GXO warehouse" |
*
* @param {Node_GxoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_gxo = /** @type {((inputs?: Node_GxoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_GxoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_gxo(inputs)
});